"use client";

import { useSyncExternalStore } from "react";

/**
 * Fuer Charts mit fest vorgegebenen Achsen-Ticks (z.B. `computeYearTicks`, `ticks={...}`
 * + `interval={0}`): bei sehr langer Historie (z.B. AAPL 1980-2026) und schmaler
 * Bildschirmbreite ueberlappen sich die Tick-Labels sichtbar, wenn immer dieselbe feste
 * Anzahl Ticks (8) erzwungen wird, unabhaengig von der verfuegbaren Breite - live an
 * einem 375px-Mobil-Viewport gefunden ("1980"/"1986" liefen ineinander).
 *
 * `useSyncExternalStore` statt `useState`+`useEffect`: matchMedia ist ein externer
 * Browser-Store, dafuer ist das der von React empfohlene Weg (kein setState-in-Effect,
 * `getServerSnapshot` liefert einen definierten SSR-Wert statt eines Hydration-Mismatch).
 */
export function useIsNarrowViewport(breakpointPx = 640): boolean {
  function subscribe(callback: () => void): () => void {
    const mq = window.matchMedia(`(max-width: ${breakpointPx}px)`);
    mq.addEventListener("change", callback);
    return () => mq.removeEventListener("change", callback);
  }
  function getSnapshot(): boolean {
    return window.matchMedia(`(max-width: ${breakpointPx}px)`).matches;
  }
  function getServerSnapshot(): boolean {
    return false;
  }

  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
